import { SheetProvider } from "../SheetProvider";
import { ISheetField } from "../Models";



export default class ShoulderSinksProvider extends SheetProvider {
    
    
    private products: any;
    
    
    
    public getFields() {
        
        var self = this;
        this.fields = {};
        
        
        //----------------------------------------------------------------------------
        //En investering i bedre håndhygiejne giver markante besparelser på bundlinjen.
        
        //Antal ansatte
        this.addField('F6', '', () => { return 10; });
        //antal biler
        this.addField('F7', '', () => { return 5; });
        
        //Shouldersink
        //Levetid/år
        this.addField('I6', '', () => { return 5; });
        //Pris pr. stk.
        this.addField('I7', '', () => { return 1975; });
        
        //Fraværdsbesparelse MED Shouldersink
        //færre sygdage dagligt
        this.addField('F11', '', () => {
            return self.fields['G11'].value() / 21.17;
        });
        //færre sygdage månedligt
        this.addField('G11', '', () => {
            return self.fields['F6'].value() *0.16;
        });
        //færre sygdage årligt
        this.addField('H11', '', () => {
            return self.fields['G11'].value() *12;
        });
        //Medarbejder omk. dagligt
        this.addField('F12', '', () => {
            return self.fields['G12'].value() / 21.17;
        });
        //Medarbejder omk. månedeligt
        this.addField('G12', '', () => {
            return self.fields['F7'].value() * 55000;
        });
        //Medarbejder omk. årligt
        this.addField('H12', '', () => {
            return self.fields['G12'].value() *12;
        });
        
        //total omk. dagligt
        this.addField('F13', '', () => {
            return self.fields['G13'].value() / 21.17;
        });

        //total omk. månedeligt
        this.addField('G13', '', () => {
            return self.fields['F6'].value() *415.68;
        });

        //total omk. årligt
        this.addField('H13', '', () => {
            return self.fields['G13'].value() *12;
        });


        //Shouldersink omk. dagligt =G14/21,17*F7
        //TODO: mso validate *
        this.addField('F14', '', () => {
            return self.fields['G14'].value() / 21.17;//*self.fields['F7'].value();
        });
        //Shouldersink omk. dagligt =I7/(I6*12)*F7
        //TODO: mso validate *
        this.addField('G14', '', () => {
            return self.fields['I7'].value() / (self.fields['I6'].value()*12)*self.fields['F7'].value();
        });
        //Shouldersink omk. dagligt G14*12*F7
        //TODO: mso validate *
        this.addField('H14', '', () => {
            return self.fields['G14'].value() * 12;// * self.fields['F7'].value();
        });
        
        //Total besparelse dagligt
        this.addField('F15', '', () => {
            return self.fields['F13'].value() - self.fields['F14'].value();
        });
        //Total besparelse månedeligt
        this.addField('G15', '', () => {
            return self.fields['G13'].value() - self.fields['G14'].value();
        });
        //Total besparelse årligt
        this.addField('H15', '', () => {
            return self.fields['H13'].value() - self.fields['H14'].value();
        });
        
        //Besparelse efter 5 år dagligt
        this.addField('F18', '', () => {
            return self.fields['F15'].value() * self.fields['I6'].value();
        });
        
        //Besparelse efter 5 år månedelig
        this.addField('G18', '', () => {
            return self.fields['G15'].value() * self.fields['I6'].value();
        });
        
        //Besparelse efter 5 år årligt
        this.addField('H18', '', () => {
            return self.fields['H15'].value() * self.fields['I6'].value();
        });
        
        
        
        return this.fields;
    }
    
    
}




        // //OTHER FROM SHEET - NOT USED FOR NOW
        // //sygefravær pr. mdr. før/efter COVID
        // this.addField('B6', '', () => { return 0.97 });
        // this.addField('B7', '', () => { return 0.81 });
        // this.addField('B8', '', () => { 
        //     return self.fields['B6'].value() - self.fields['B7'].value();  
        // });
        
        // //Gns. Antal arbejdsdage pr. mdr.
        // this.addField('B10', '', () => { return 21.7 });
        // //Gns. Omkostning pr medarbejder incl firmabil pr md.
        // this.addField('B12', '', () => { return 55000 });
        // //Gns. Omkostning pr arbejdsdag
        // this.addField('B14', '', () => {
        //     return self.fields['B12'].value() / self.fields['B10'].value();
        // });
        // //Besparelse på mindre sygefravær - pr md
        // this.addField('B16', '', () => {
        //     return self.fields['B14'].value() / self.fields['B8'].value();
        // });
        // //Besparelse på mindre sygefravær pr år
        // this.addField('B18', '', () => {
        //     return self.fields['B16'].value() * 12;
        // });
        // //Levetid på Shouldersink - år
        // this.addField('B20', '', () => { return 5 });
        // //Besparelse på mindre sygefravær i Shouldersink levetid
        // this.addField('B22', '', () => {
        //     return self.fields['B18'].value() / self.fields['B20'].value();
        // });
        // //Anskaffelsespris på Shouldersink 
        // this.addField('B24', '', () => { return 1975 });
        
        // //Pris på Shouldersink pr arbejdsdag i levetid excl produkter
        // this.addField('B26', '', () => {
        //     //=B24/((B10*12)*5)
        //     return self.fields['B24'].value() / ((self.fields['B10'].value()*12)*5);
        // });
        // //ROI/mnd
        // this.addField('B28', '', () => {
        //     return self.fields['B24'].value() / self.fields['B26'].value();
        // });
        // //Fortjeneste til virksomhed i Shouldersink levetid
        // this.addField('B30', '', () => {
        //     return self.fields['B22'].value() - self.fields['B24'].value();
        // });
        
        
        // //Fortjeneste over 5 år
        // // Flådestørelser:
        // // Kemp & Lauritzen
        // this.addField('B33', '', () => { return 1143 });
        // this.addField('C33', '', () => {
        //     return self.fields['B33'].value() * self.fields['B30'].value();
        // });
        // // El-con
        // this.addField('B34', '', () => { return 550 });
        // this.addField('C34', '', () => {
        //     return self.fields['B34'].value() * self.fields['B30'].value();
        // });
        // // Bravida
        // this.addField('B35', '', () => { return 1049 });
        // this.addField('C35', '', () => {
        //     return self.fields['B35'].value() * self.fields['B30'].value();
        // });
        // // Munck
        // this.addField('B36', '', () => { return 644 });
        // this.addField('C36', '', () => {
        //     return self.fields['B36'].value() * self.fields['B30'].value();
        // });
        
        // //         * Kilde: Vejle Kommune - eksempel fra Maj 2020 / Maj 2019
        
        // // Opgørelse over sygefravær er opgjort i medarbejder kostpriser - det vil sige, at virksomhedens fortjenest pr medarbejder ikke medregnet. 
        // // Ej heller er virksomhedens omkostning til overarbejdsbetaling til andre medarbejdere grundet sygefravær.
        
        // //END DELETE
        